import { render, staticRenderFns } from "./InnerPacketBuy.vue?vue&type=template&id=99f8349e&scoped=true&"
import script from "./InnerPacketBuy.vue?vue&type=script&lang=js&"
export * from "./InnerPacketBuy.vue?vue&type=script&lang=js&"
import style0 from "./InnerPacketBuy.vue?vue&type=style&index=0&id=99f8349e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f8349e",
  null
  
)

export default component.exports